import { DOCUMENT } from '@angular/common';
import { Injectable, Inject } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class JSONLDService {
    constructor(@Inject(DOCUMENT) private document: Document) {}

    createSchema(markup: {}) {
        const script = this.document.createElement('script');
        script.type = 'application/ld+json';
        script.innerHTML = this.getSafeHTML(markup);
        this.document.head.appendChild(script);
    }

    getSafeHTML(value: {}) {
        // If value convert to JSON and escape / to prevent script tag in JSON
        const json = value ? JSON.stringify(value, null, 2).replace(/\//g, '\\/') : '';
        const html = `${json}`;
        return html;
    }
}
